import { useState } from "react";
import EditThemeModal from "../modal/EditThemeModal";

const ThemeCard = ({
    id,
    title = "Без названия",
    questionCount = 0,
    webinarRoomId,
    webinarPreviewUrl, // ✅ Теперь берем превью напрямую из темы
    onDelete,
    onUpdate,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            {/* 🔥 Теперь модалка открывается при клике на карточку */}
            <div
                className="relative shrink-0 basis-[278px] bg-lavender-8 rounded-2xl p-2 cursor-pointer hover:shadow-lg transition-shadow"
                onClick={() => setIsModalOpen(true)}
            >
                {/* Превью вебинара */}
                <div className="relative w-full min-h-[123px] bg-lavender rounded-xl flex items-end p-2 gap-1">
                    {webinarPreviewUrl ? (
                        <img src={webinarPreviewUrl} alt="Превью вебинара" className="w-full h-full object-cover rounded-xl" />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gray-200 rounded-xl">
                            <span className="text-gray-500 text-sm">Нет превью</span>
                        </div>
                    )}
                    {questionCount > 0 && (
                        <span className="absolute top-2 left-2 bg-white text-lavender-700 px-3 py-1 rounded-full text-xs font-semibold shadow">
                            {questionCount} вопросов
                        </span>
                    )}
                </div>
                {/* Название */}
                <div className="py-4 px-2 leading-5">
                    <h4 className="font-semibold">{title}</h4>
                </div>
            </div>

            {/* 🔥 Модалка редактирования теперь открывается по клику на карточку */}
            {isModalOpen && (
                <EditThemeModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    themeData={{
                        id,
                        title,
                        webinar_room_id: webinarRoomId,
                        webinar_preview_url: webinarPreviewUrl, // ✅ Передаем в модалку
                    }}
                    onUpdate={onUpdate}
                    onDelete={onDelete}
                />
            )}
        </>
    );
};

export default ThemeCard;
